export default "__VITE_ASSET__yIXgjgm2__"